export default __webpack_public_path__ + "static/media/most-view-blog.ad68621b.png";